<div class="container">
  <h1 class="text-center fs-3 my-3">TypeScript Fastify</h1>

  <div class="row g-3 align-items-center border rounded p-3">
    <div class="col-12 col-md-auto">
      <button
        type="button"
        class="btn btn-primary"
        (click)="consultarBackend()">
        Hello
      </button>
    </div>

    <div class="col-12 col-md-auto">
      <label for="respuesta-python" class="form-label">Respuesta del backend</label>
      <textarea
        id="respuesta-python"
        class="form-control"
        cols="80"
        rows="10"
        [value]="respuesta()"
        readonly></textarea>
    </div>
  </div>

  <form #notificacionForm="ngForm" (ngSubmit)="notificar()" class="row g-3 align-items-end border rounded p-3 mt-3">
    <div class="col-12 col-md-auto">
      <button type="submit" class="btn btn-primary" [disabled]="notificacionForm.invalid || !titulo.trim() || !texto.trim() || enviandoNotificacion()">
        Notificar
      </button>
    </div>

    <div class="col-12 col-md-4">
      <label for="titulo-notificacion" class="form-label">Título</label>
      <input id="titulo-notificacion" name="titulo" type="text" class="form-control" required [(ngModel)]="titulo" />
    </div>

    <div class="col-12 col-md-5">
      <label for="texto-notificacion" class="form-label">Mensaje</label>
      <input id="texto-notificacion" name="texto" type="text" class="form-control" required [(ngModel)]="texto" />
    </div>
    @if (estadoNotificacion()) {
    <div  class="col-12" role="status" aria-live="polite">{{ estadoNotificacion() }}</div>
    }
  </form>
</div>
